var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"column-selector"}},[_c('button',{class:_vm.btnClass,attrs:{"type":"button"},on:{"click":function($event){return _vm.getTemplate()}}},[_vm._v("\n      Liberar para o app\n    ")])])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53ce6fde","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/SharePosters.vue
// module id = HiZ3
// module chunks = 101